import VehicleType from '@/enums/VehicleType';
import IRetailerVehicleAvailability from '@/models/test-drive/interfaces/retailer-vehicle-availability.d';
import RetailerVehicleAvailability from '@/models/test-drive/retailer-vehicle-availability';

class RetailerService {
  private static serviceInstance: RetailerService;

  public static get instance() {
    // eslint-disable-next-line no-return-assign
    return this.serviceInstance || (this.serviceInstance = new this());
  }

  private get apiDomain() : string {
    let env = 'prod';

    try {
      const { hostname } = window.location;

      if (hostname.startsWith('dev-') || hostname.startsWith('local-')) {
        env = 'dev';
      } else if (hostname.startsWith('qa-')) {
        env = 'qa';
      }
    } catch (error) {
      window.console.error(
        'Failed to check hostname for env.',
        { error }
      );
    }

    return `https://px-func-front-end-functions-${env}.azurewebsites.net`;
  }

  public getAvailability(
    vehicleType: VehicleType,
    manufacturerId: number,
    rangeId: number,
    modelId: number,
    bodyStyle: string | null,
    fuelType: string | null,
    latitude: number,
    longitude: number,
    retailerLimit: number
  ): Promise<IRetailerVehicleAvailability[]> {
    let queryStrings = `daysAhead=30&numberOfRetailers=${retailerLimit}`;

    if (modelId > 0) {
      queryStrings += `&modelId=${modelId}`;
    }

    if (bodyStyle && bodyStyle.length > 0) {
      queryStrings += `&bodyStyle=${bodyStyle}`;
    }

    if (fuelType && fuelType.length > 0) {
      queryStrings += `&fuelType=${fuelType}`;
    }

    return fetch(`${this.apiDomain}/api/test-drive-retailer/${vehicleType}/manufacturer/${manufacturerId}/range/${rangeId}/latitude/${latitude}/longitude/${longitude}?${queryStrings}`)
      .then((response) => response.json())
      .then((json: any) => json.map(
        (item: any) => new RetailerVehicleAvailability(
          item.testDriveVehicleId,
          item.retailerId,
          item.retailerName,
          item.address,
          item.location,
          item.distanceInMiles,
          item.availability.map((a) => ({ availableDate: new Date(a.availableDate), availableSlots: a.availableSlots, totalSlots: a.totalSlots }))
        )
      ))
      .catch((error) => {
        console.log('There was an issue calling the Test Drive availability API', error);

        return [];
      });
  }
}

// export a singleton instance in the global namespace
// eslint-disable-next-line import/prefer-default-export
export const retailerService = RetailerService.instance;
